// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right-border[data-v-5fff0a1e] {\n  border-right: 1px solid #e6e6e6;\n  border-right-width: 1px;\n  height: 40%;\n}\nth[data-v-5fff0a1e] {\n  font-weight: 400 !important;\n}\n", ""]);
// Exports
module.exports = exports;
